<template>
  <div class="top-wrapper">
    <div class="top-content">
      <v-container>
        <v-layout class="app-info" wrap>
          <v-flex xs12 sm12 md6 lg4>
            <v-layout align-start justify-start column>
              <v-flex class="pre-title">Made by Trützschler</v-flex>
              <h1>My Wires</h1>

              <v-flex class="download-block">
                <p>
                  For better experience we recommend using native apps on smaller devices
                </p>
                <v-layout row class="store-buttons" wrap>
                  <v-flex>
                    <a href="https://apps.apple.com/us/app/my-wires/id1468286046?l=de&ls=1" target="_blank">
                      <icon-base width="165" height="55" viewBox="0 0 165 55"> <icon-app-store /> </icon-base>
                    </a>
                  </v-flex>
                  <v-flex>
                    <a href="https://play.google.com/store/apps/details?id=de.truetzschler.mywires2" target="_blank">
                      <icon-base width="150" height="55" viewBox="0 0 165 55"><icon-google-play /> </icon-base>
                    </a>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md6 lg7 offset-lg1>
            <v-carousel hide-controls> <v-carousel-item v-for="(item, i) in items" :key="i" :src="item"></v-carousel-item> </v-carousel
          ></v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase';
import IconGooglePlay from '@/components/icons/IconGooglePlay';
import IconAppStore from '@/components/icons/IconAppStore';

export default {
  components: {
    IconBase,
    IconGooglePlay,
    IconAppStore
  },
  data() {
    return {
      items: [
        require('@/assets/images/landing-carousel-1.png'),
        require('@/assets/images/landing-carousel-2.png'),
        require('@/assets/images/landing-carousel-3.png')
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.top-wrapper {
  width: 100%;
  color: #fff;
  background-image: url('./../assets/images/landing-top.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  .top-content {
    padding-top: 0px;
    position: relative;
  }
  .app-info {
    margin-top: 50px;
    .pre-title {
      font-size: 14px;
    }
    h1 {
      font-size: 56px;
      font-weight: 500;
    }
  }
  .download-block {
    margin-top: 50px;
    font-size: 18px;
    line-height: 1.78;
    .store-buttons {
      margin-top: 30px;
      min-height: 70px;
      width: 100%;
    }
  }
  .v-carousel {
    box-shadow: none;
  }
}
@media screen and (max-width: 600px) {
  .mobile-burger {
    display: block;
  }
  .landing-header {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .contact-wrapper {
    h1 {
      font-size: 36px;
    }
    input {
      width: 270px;
    }
  }
  .download-block {
    .store-buttons {
      .flex {
        display: block;
        width: 100%;
        flex: 2 2 auto;
        flex-grow: 0;
        flex-basis: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
.top-wrapper {
  .v-carousel__controls {
    background: transparent;
  }
  .v-window.v-carousel {
    height: 540px !important;
    .v-window__container {
      max-width: 500px;
      height: 500px;
      margin: 0 auto;
      .v-image__image.v-image__image--cover {
        background-size: contain;
      }
    }
  }
}
</style>
